import type { ChatMessage } from './types';

/**
 * How many messages to keep when regenerating the last reply.
 *
 * The previous assistant turn is discarded and the question that produced it is
 * asked again, so the cut has to fall *before* that question — keeping it would
 * leave the thread as [.., question, question, reply].
 *
 * Returns `null` when there is nothing to regenerate, so the caller can bail
 * without truncating the thread.
 */
export function computeRegenerateKeep(messages: ChatMessage[]): number | null {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i].role === 'user') {
      return i;
    }
  }
  return null;
}

/**
 * How many messages to keep when editing the question at `index`.
 *
 * Editing branches the conversation: the edited message and everything after it
 * go, and the new question is appended in their place.
 */
export function computeEditKeep(messages: ChatMessage[], index: number): number | null {
  if (index < 0 || index >= messages.length) return null;
  if (messages[index].role !== 'user') return null;
  return index;
}